// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.D3VizEngineConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import * as d3 from 'd3';

export default {
  SYMBOL_LIST: [d3.symbolCircle, d3.symbolDiamond],
  SYMBOL_SIZE: 40,
  MARGIN: {
    left: 10,
    right: 10,
    top: 10,
    bottom: 15
  },
  // The spacing of tooltip compare to the middle in vertical
  TOOLTIP_VERTICAL_SPACING: 50,
  // The spacing of tooltip compare to the middle in horizontal
  TOOLTIP_HORIZONTAL_SPACING: 25,
  // Animation transition time
  TRANSITION_DURATION: 500,
  // Each percent of the chart each time the raf call
  ANIMATION_PORTION: 20,
  // Opacity value when hover on point
  HOVER_OPACITY: 0.7,
  // Amount of pixel allow the label to overlap others rectangles
  LABEL_ADDITION_MARGIN: 10,
  // Amount of percent of em to shift the label
  LABEL_BASELINE_SHIFT: 0.92,
  // Disable legend color
  DISABLE_LEGEND_COLOR: '#CCC',
  // Class name and z-index for layout graphics
  LAYOUT_CLASSES: {
    background: { class: 'd3-background', 'z-index': 0 },
    plotBackground: { class: 'd3-plot-background', 'z-index': 0},
    seriesGroup: { class: 'd3-series-group', 'z-index': 1 },
    labelGroup: { class: 'd3-label-group', 'z-index': 2 },
    legend: { class: 'd3-legend', 'z-index': 3}
  },
  // Treemap banner height
  TREEMAP_BANNER_HEIGHT: 20
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.D3VizEngineConstants.js